import _get from 'hs-lodash/get';
import { getFullUrl } from 'hubspot-url-utils';
import baseHttpClient from '../../utils/apiClient';
const playbookContentFilter = {
  field: 'content_type',
  values: ['PLAYBOOK']
};
const playbookPublicationStageFilter = {
  field: 'publication_stage',
  values: ['PUBLISHED', 'PUBLISHED_WITH_EDITS']
};
const defaultQuery = {
  filters: [playbookContentFilter, playbookPublicationStageFilter],
  limit: 3,
  offset: 0,
  query: '',
  sorts: [{
    field: 'updated_at',
    order: 'DESC'
  }]
};
export const fetchPlaybooks = (query = {}) => {
  return baseHttpClient.post(`${getFullUrl('app-api')}/salescontentsearch/v2/search`, {
    data: Object.assign({
      contentTypesToHydrate: ['PLAYBOOK']
    }, defaultQuery, query)
  }).then(response => {
    const results = response.results.map(el => {
      if (!_get(el, 'metadata.usageDetails')) {
        return Object.assign({}, el, {
          metadata: {
            usageDetails: null
          }
        });
      }
      return el;
    });
    return Object.assign({}, response, {
      results
    });
  });
};
export const fetchRecommendedPlaybooks = (objectType, objectId) => {
  return baseHttpClient.get(`${getFullUrl('app-api')}/playbooks/v1/recommendations?objectTypeId=${objectType}&objectId=${objectId}`).then(res => res.map(({
    properties: {
      hs_playbook_title,
      hs_playbook_id,
      hs_playbook_type
    }
  }) => ({
    name: hs_playbook_title.value,
    contentId: parseInt(hs_playbook_id.value, 10),
    metadata: {
      playbookType: hs_playbook_type.value
    },
    recommended: true
  })));
};